import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { SharedPersonalAutofillValues } from "@/shared/stepper/PersonalDetailsFormStep";

interface PersonalDetailsState {
  autofillData: SharedPersonalAutofillValues;
}

const initialState: PersonalDetailsState = {
  autofillData: {},
};

const personalDetailsSlice = createSlice({
  name: "autofillPersonalDetails",
  initialState,
  reducers: {
    setPersonalDetailsAutofill: (state, action: PayloadAction<SharedPersonalAutofillValues>) => {
      state.autofillData = action.payload;
    },
    clearPersonalDetailsAutofill: (state) => {
      state.autofillData = {};
    },
  },
});

export const { setPersonalDetailsAutofill, clearPersonalDetailsAutofill } =
  personalDetailsSlice.actions;

export const { reducer: autoPersonalDetailsReducer } = personalDetailsSlice;
